class ModuleMap {
    constructor () {
        this.listHandler = {};
    }
}

let moduleMap = new ModuleMap();

export default moduleMap;